import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '@mui/material';
import { Typography, colors, IconGraphy } from '@leapeasy/ui-kit';
import logo from 'assets/logo_horizontal.png';
import { Menu } from 'components/Menu';
import { primaryMenu, secondaryMenu } from 'data/ui/menu';

import collapsedLogo from 'assets/logo-sm.png';
import { useDispatch } from 'react-redux';
import { collapsedAction } from 'store/actions/uiActions';
import { SIDEBAR_MOBILE_MAX_WIDTH } from 'constants/layoutBreakpoints';

export const Sidebar = React.memo(({ isMobile, collapsed, hideCollapseToggle = false }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  // const collapsed = useSelector((state) => state.getIn(['ui', 'collapsed']));
  const dispatch = useDispatch();

  return (
    <SidebarWrapper isMobile={isMobile} collapsed={collapsed}>
      {!hideCollapseToggle && (
        <Box
          sx={{
            position: 'absolute',
            top: 14,
            right: collapsed ? '-48px' : '-16px',
            cursor: 'pointer',
            transition: 'all 0.5s ease',
            width: 32,
            height: 32,
            borderRadius: '8px',
            backgroundColor: '#f3eef6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
          aria-label="toggle menu"
          onClick={() => {
            const nextCollapsedState = !collapsed;
            localStorage.setItem('sidebarCollapsed', `${nextCollapsedState}`);
            dispatch(collapsedAction(nextCollapsedState));
          }}
        >
          <IconGraphy
            icon="EditorLayout.MenuOpen"
            style={{
              color: colors.purple[700],
              transform: collapsed ? 'scaleX(-1)' : 'none',
              transition: 'transform 0.2s ease',
            }}
          />
        </Box>
      )}
      <Container background={colors.purple[700]} collapsed={collapsed}>
        <Box
          sx={{
            borderBottom: '1px solid rgba(234, 234, 234, 0.1)',
            padding: '12px 24px',
          }}
          display="flex"
          flexDirection="column"
          gap="4px"
          paddingLeft={collapsed && 12}
        >
          <img
            alt="logo"
            src={collapsed ? collapsedLogo : logo}
            style={{
              width: collapsed ? '30px' : '100px',
              height: 31,
              transition: 'all 0.5s ease',
              marginLeft: collapsed && '-15px',
            }}
          />

          <Typography
            variant="cta-xs"
            style={{
              color: '#DAD4DD',
              fontWeight: 500,
              textAlign: 'center',
              width: '100px',
              opacity: collapsed ? 0 : 1,
              transition: 'all 0.5s ease',
            }}
          >
            Portal
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1, borderBottom: '1px solid rgba(234, 234, 234, 0.1)' }}>
          <Menu isOpen={isMenuOpen} data={primaryMenu} collapsed={collapsed} />
        </Box>

        <Box>
          <Menu isOpen={isMenuOpen} data={secondaryMenu} collapsed={collapsed} />
        </Box>
      </Container>
    </SidebarWrapper>
  );
});

const SidebarWrapper = styled.div`
  max-width: ${(props) => (props.collapsed ? '70px' : '240px')};
  min-width: ${(props) => (props.collapsed ? '70px' : '240px')};
  min-height: 100vh;
  max-height: 100vh;
  height: 100%;
  ${(props) =>
    props.isMobile &&
    css`
      @media screen and (max-width: ${SIDEBAR_MOBILE_MAX_WIDTH}) {
        display: none;
      }
    `}
  transition: all 0.5s ease;
  position: relative;
  overflow: visible;
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 12px 12px 20px;
  gap: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: ${(props) => props.background};
  width: 100%;
  overflow-y: ${(props) => (props.collapsed ? 'visible' : 'auto')};
  overflow-x: ${(props) => (props.collapsed ? 'visible' : 'hidden')};
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(234, 234, 234, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(234, 234, 234, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(234, 234, 234, 0.5);
  }
`;
